namespace $.$$ {
	type Save = { definition: $shm_hitalama_map_widget_entity_custom, kind: $shm_hitalama_map_widget_entity_custom_source_kind, text: string, key: string }
	export class $shm_hitalama_components_source extends $.$shm_hitalama_components_source {
		private pending = new Map< string, Save >
		private active = false
		@ $mol_mem_key
		draft( key: string, next?: string | null ): string | null { return next ?? null }
		@ $mol_mem_key
		failure_at( key: string, next?: string ) { return next ?? '' }
		failure() { return this.failure_at( this.definition().link().str + ':' + this.kind() ) }
		value( next?: string ): string {
			const definition = this.definition(), kind = this.kind() as Save['kind']
			const key = definition.link().str + ':' + kind
			if( next === undefined ) return this.draft( key ) ?? definition.source_text( kind )
			this.draft( key, next )
			this.request({ definition, kind, key, text: next })
			return next
		}
		@ $mol_action
		request( request: Save ) {
			this.pending.set( request.key, request )
			this.failure_at( request.key, '' )
			if( !this.active ) this.start()
		}
		private start() {
			const request = this.pending.values().next().value!
			this.pending.delete( request.key )
			this.active = true
			this.saving( true )
			// Keep a live async action: $mol_string's input handler catches suspension.
			// Serialize writes so an older save cannot overwrite a newer local edit.
			$mol_wire_async( this ).save( request ).then(
				()=> this.done( request ),
				error => this.done( request, error ),
			)
		}
		save( request: Save ) { return request.definition.source_text( request.kind, request.text ) }
		@ $mol_action
		private done( request: Save, error?: unknown ) {
			this.active = false
			if( !this.pending.has( request.key ) ) {
				if( error ) this.failure_at( request.key, 'Не удалось сохранить код: ' + String( error ) )
				else this.draft( request.key, null )
			}
			if( this.pending.size ) this.start()
			else this.saving( false )
		}
	}
}
